<template>
  <div id="app">
    <router-view />
  </div>
  <Teleport to="#loading">
    <div id="loading-cpn">
      <div class="loading__component">
        <q-spinner color="primary" size="4em" :thickness="10" />
      </div>
    </div>
  </Teleport>
  <Teleport to="#popup">
    <MISAPopup></MISAPopup>
  </Teleport>
  <Teleport to="#dialog">
    <MISADialog></MISADialog>
  </Teleport>
  <Teleport to="body"> </Teleport>
  <Teleport to="#message-box">
    <modals-container></modals-container>
    <dialog-wrapper />
  </Teleport>
</template>

<script>
import { DialogWrapper } from 'vue3-promise-dialog';
import MainLayout from './layouts/MainLayout.vue';
import MISADialog from '@/components/common/misa-dialog/MISADialog.vue';
import MISAPopup from '@/components/common/misa-popup/MISAPopup.vue';

export default {
  components: {
    DialogWrapper,
    MainLayout,
    MISADialog,
    MISAPopup,
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    const me = this;

    // xử lý dbOption NXCHIEN 08.07.2022
    let dbOptions = this.$store.state.dbOption.dbOptions || {};
    if (
      Object.keys(dbOptions).length == 0 &&
      this.$store.state.context?.Token
    ) {
      // this.$store.dispatch(`${ModuleDbOption}/getDbOptions`);
    }
  },

  beforeUnmount() {
  if (this.$signal._connection?.state == 'Connected') {
    let partners = this.$store.state?.globalcontext?.Partners?.map((item) => item.partner_id);
    if (partners && partners.length > 0) {
      this.$signal.leaveGroups(partners);
    }
  }
  this.$signal.stop();

  },
  methods: {},
};
</script>
<style lang="sass">
@import './assets/scss/base.scss'
</style>
